<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    name: {
      required: true,
    },
    form: {
      required: true,
      type: Array,
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true,
    },

    user: {
      type: String,
      default() {
        return ''
      },
    },
  },
  data() {
    return {
      show: false,
      count: 0,
      countDisp: 0,
    }
  },
  beforeDestroy() {
    this.$root.$off(this.name)
    this.$root.$off('dependency')
    var doc = this.$refs[this.name + 'hideshow']
    if (doc !== undefined) doc.innerHTML = ''
    // console.log('destroyed hide-show')
    // remove the element from the DOM
    // if (this.$el.parentNode !== null) this.$el.parentNode.removeChild(this.$el)
    // this.$destroy();
  },
  mounted() {
    this.$root.$on(this.name, (data) => {
      var status = true
      if (data.status !== undefined) {
        status = data.status
      }

      if (data.name === this.name) {
        if (!Array.isArray(this.options.show)) {
          if (data.value === this.options.show) {
            this.getTotalField()
            if (status) this.setData(status)
            this.show = true
          } else {
            this.show = false
            // console.log(this.form.length)
            this.removeData(status)
          }
        } else {
          const check = JSON.parse(JSON.stringify(this.options.show))

          if (check.indexOf(data.value) !== -1) {
            this.getTotalField()
            this.show = true
          } else {
            this.show = false
            this.removeData(status)
          }
        }
      }
    })
  },

  methods: {
    getTotalField() {
      this.count = 0
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].typeComponent !== 'FormBaseNote')
          if (
            this.form[i].typeComponent === 'FormBaseAddmore' ||
            this.form[i].typeComponent === 'FormFormBasePreviousName' ||
            this.form[i].typeComponent === 'FormFormBaseSelectFileAddmore'
          ) {
            this.$root.$emit('hide', { name: this.form[i].name, count: 1 })
            this.$root.$emit('removedHide', {
              name: this.form[i].name,
              count: 0,
            })
          } else {
            if (this.form[i].form !== undefined) {
              for (var j = 0; j < this.form[i].form.length; j++) {
                this.$root.$emit('hide', {
                  name: this.form[i].form[j].name,
                  count: 1,
                })
                this.$root.$emit('removedHide', {
                  name: this.form[i].form[j].name,
                  count: 0,
                })
              }
            }
          }
      }
    },
    getRemovedFields() {
      this.$root.$emit('removedHide', { name: this.name, count: 1 })
    },
    setData(status) {
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].typeComponent !== 'FormBaseNote')
          if (
            this.form[i].typeComponent === 'FormBaseAddmore' ||
            this.form[i].typeComponent === 'FormFormBasePreviousName' ||
            this.form[i].typeComponent === 'FormFormBaseSelectFileAddmore'
          ) {
            if (status) this.editData({ name: this.form[i].name, data: null })
          } else {
            if (this.form[i].form !== undefined)
              for (var j = 0; j < this.form[i].form.length; j++) {
                if (status) {
                  if (this.form[i].form[j].typeComponent !== 'FormBaseNote')
                    this.editData({
                      name: this.form[i].form[j].name,
                      data: null,
                    })
                }
              }
          }
      }
    },
    removeData(status) {
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].typeComponent !== 'FormBaseNote')
          if (
            this.form[i].typeComponent === 'FormBaseAddmore' ||
            this.form[i].typeComponent === 'FormFormBasePreviousName' ||
            this.form[i].typeComponent === 'FormFormBaseSelectFileAddmore'
          ) {
            if (this.form[i].typeComponent === 'FormBaseAddmore') {
              var sampleval = this.value
              if (this.form[i].form !== undefined)
                for (var j = 0; j < this.form[i].form.length; j++) {
                  if (status) {
                    if (this.form[i].form[j].typeComponent === 'FormBaseFile') {
                      var depthval = {}
                      if (sampleval[this.form[i].name] !== undefined)
                        for (
                          var x = 0;
                          x < sampleval[this.form[i].name].length;
                          x++
                        ) {
                          depthval = sampleval[this.form[i].name][x]

                          if (
                            depthval[this.form[i].form[j].name] !== undefined &&
                            depthval[this.form[i].form[j].name] !== null
                          )
                            this.$root.$emit(
                              'deleteFile',
                              depthval[this.form[i].form[j].name]
                            )
                        }
                    }
                  }
                }
              //  var parent = this
              /*  setTimeout(() => {
                console.log(parent.form[i]);
                if (status)
                  parent.editData({ name: parent.form[i].name, data: null })

                parent.$root.$emit('removedHide', {
                  name: parent.form[i].name,
                  count: 1,
                })
                parent.$root.$emit('hide', {
                  name: parent.form[i].name,
                  count: 1,
                })
              }, 1000) */
              if (status) this.editData({ name: this.form[i].name, data: null })

              this.$root.$emit('removedHide', {
                name: this.form[i].name,
                count: 1,
              })
              this.$root.$emit('hide', {
                name: this.form[i].name,
                count: 1,
              })
            }
          } else {
            if (this.form[i].form !== undefined)
              for (j = 0; j < this.form[i].form.length; j++) {
                if (status) {
                  if (this.form[i].form[j].typeComponent === 'FormBaseFile') {
                    if (
                      this.value[this.form[i].form[j].name] !== undefined &&
                      this.value[this.form[i].form[j].name] !== null
                    )
                      this.$root.$emit(
                        'deleteFile',
                        this.value[this.form[i].form[j].name]
                      )
                  }
                  if (this.form[i].form[j].typeComponent !== 'FormBaseNote')
                    this.editData({
                      name: this.form[i].form[j].name,
                      data: null,
                    })
                }
                if (this.form[i].form[j].typeComponent !== 'FormBaseNote') {
                  this.$root.$emit('removedHide', {
                    name: this.form[i].form[j].name,
                    count: 1,
                  })
                  this.$root.$emit('hide', {
                    name: this.form[i].form[j].name,
                    count: 1,
                  })
                }
              }
          }
      }
      // this.getRemovedFields()
    },
    deleteData(data) {
      this.$emit('delete', data)
    },
    sendData(data) {
      //  console.log(data)
      this.$emit('update', data)
    },
    editData(data) {
      //    console.log(data)
      this.$emit('edit', data)
    },
    changeStoredData() {},
  },
}
</script>
<template>
  <div :ref="name + 'hideshow'">
    <div class="clear"></div>
    <div :class="$style.bodyContentBorder"></div>
    <div class="clear"></div>

    <div v-if="show">
      <div v-for="(field, key) in form" :key="key">
        <component
          :is="field.typeComponent"
          :value="value"
          :form="field.form"
          :name="field.name"
          :options="field.options"
          :user="user"
          :api="field.api"
          @edit="editData($event)"
          @update="editData($event)"
          @delete="deleteData"
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
</style>
